import { Navigate, useLocation } from 'react-router-dom';
import { useMainContext } from './hooks/useMainContext';
import { observer } from 'mobx-react-lite';

const PublicRoute = observer(({ children }) => {
    const { viewManager } = useMainContext();
    const location = useLocation();

    if (viewManager.isLoggedIn) {
        // Preserve query params when redirecting
        return <Navigate to={`/${location.search}`} replace />;
    }

    return children;
});
export default PublicRoute;
